export default __webpack_public_path__ + "static/media/carjoin1.53c2ecc2.png";